export default __webpack_public_path__ + "static/media/gora7.61fc300e.jpg";